import "./ProductPageLoader.css";

const ProductPageLoader = ({ fadeOut }) => {
  return (
    <div className={`product-loader${fadeOut ? " product-loader-fade-out" : ""}`}>
      {/* Animated diamond with rings */}
      <div className="product-loader-diamond-wrap">
        <div className="product-loader-ring" />
        <div className="product-loader-ring-inner" />
        <div className="product-loader-diamond" />

        {/* Sparkle particles */}
        <div className="product-loader-sparkles">
          {[...Array(8)].map((_, i) => (
            <span key={i} className="product-loader-sparkle" />
          ))}
        </div>
      </div>

      {/* Gold divider */}
      <div className="product-loader-divider" />

      {/* Loading text */}
      <div className="product-loader-text">Loading Product</div>

      {/* Skeleton preview */}
      <div className="product-loader-skeleton">
        <div>
          <div className="product-loader-skel-image" />
          <div className="product-loader-skel-thumbs">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="product-loader-skel-thumb" />
            ))}
          </div>
        </div>
        <div className="product-loader-skel-details">
          <div className="product-loader-skel-line skel-short" />
          <div className="product-loader-skel-line skel-title" />
          <div className="product-loader-skel-line skel-price" />
          <div className="product-loader-skel-line skel-long" />
          <div className="product-loader-skel-line skel-medium" />
          <div className="product-loader-skel-pills">
            {[1, 2, 3].map((i) => (
              <div key={i} className="product-loader-skel-pill" />
            ))}
          </div>
          <div className="product-loader-skel-pills">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="product-loader-skel-pill" />
            ))}
          </div>
          <div className="product-loader-skel-btn" />
        </div>
      </div>
    </div>
  );
};

export default ProductPageLoader;
